import { FETCH_DATA_RESULTS, FETCHED_DATA_RESULTS, SEARCH_RESULT_ISICS, SELECT_RESULT_ISIC, SELECT_ALL_RESULT_ISICS } from './DataResultsActions'

const dataResultsReducer = (state = { searchParameter: "", dataResults: [], isFetching: false, isResultFetched: false, dataResultForGraph: [], dataResultYearsInColumn: [], uniqReturnedYears: []}, action) => {

    function sort(a, b, asc) {
        var result;

        /* Default ascending order */
        if (typeof asc === "undefined") asc = true;

        if (a === null) return 1;
        if (b === null) return -1; 
        if (a === null && b === null) return 0;

        result = a - b;

        if (isNaN(result)) {
            return (asc) ? a.toString().localeCompare(b) : b.toString().localeCompare(a);
        }
        else {
            return (asc) ? result : -result;
        }
    }

    const searchIsics = (isic) => {
        let isicTested = { ...isic, isMatchSearch: false }
        if (action.searchParameter === "") {
            isicTested.isMatchSearch = true;
            return isicTested;
        }

        if ((isic.c + ' ' + isic[action.activeLangCode]).toLowerCase().includes(action.searchParameter ? action.searchParameter.toLowerCase() : state.searchParameter.toLowerCase())) {
            isicTested.isMatchSearch = true;
        }

        return isicTested;
    }

    function comparer(a, b) {
        return sort(a.y, b.y, false) || sort((a.ic + " " + a.in), (b.ic + " " + b.in), true);
    }

    // function comparerYearsAsc(a, b) {
    //     return sort(a, b, true)
    // }

    switch (action.type) {
        case FETCH_DATA_RESULTS:
            return {
                ...state,
                isFetching: true,
                isResultFetched: false,
                dataResults: [],
                dataResultYearsInColumn: []
            }
        case FETCHED_DATA_RESULTS:
            let dataResult = action.data.map(x => ({ ...x, ic: action.isics.filter(y => y.id === x.a)[0].c, in: action.isics.filter(y => y.id === x.a)[0].n }), ).sort(comparer);
            let dataResultForGraph = []
            let dataResultYearsInColumn = []

            dataResultForGraph = action.isics.filter(x => x.selected)
                .map((isic, index) => {
                    return {
                        id: isic.id,
                        name: isic.c,
                        c: isic.c,
                        en: isic.en,
                        ar: isic.ar,
                        type: "line",
                        shape: "spline",
                        mode: "lines+markers",
                        line: { shape: "spline" },
                        isMatchSearch: true,
                        selected: (index === 0 ? true : false),
                        x: dataResult.filter(x => x.a === isic.id).map(x => x.y),
                        y: dataResult.filter(x => x.a === isic.id).map(x => x.v)
                    }
                })
            
            dataResultYearsInColumn = action.isics.filter(x => x.selected)

            let uniqReturnedYears// = [...(new Set(dataResult.map(({ y }) => y)))].sort(comparerYearsAsc)
            uniqReturnedYears = action.years.filter(x => x.selected).map(x => x.y)

            dataResultYearsInColumn = dataResultYearsInColumn.map(x => {
                let newValue = {...x, years: {}}
                uniqReturnedYears.forEach((year, index) => {
                    newValue.years[year] = dataResult.filter(x=> x.a === newValue.id && x.y === year).map(x => x.v)[0]
                })
                return newValue
            })

            return {
                isFetching: false,
                isResultFetched: true,
                searchParameter: "",
                dataResults: dataResult,
                dataResultForGraph: dataResultForGraph,
                dataResultYearsInColumn,
                uniqReturnedYears
            } 
        case SEARCH_RESULT_ISICS:
        return {
            ...state,
            searchParameter: action.searchParameter,
            dataResultForGraph: state.dataResultForGraph.map(searchIsics)
        }
        case SELECT_RESULT_ISIC:
          return {
            ...state,
            dataResultForGraph: state.dataResultForGraph.map((isic) => {
              if (isic.id === action.resultIsicId) {
                return { ...isic, selected: !isic.selected }
              }
              return isic
            })
        }
        case SELECT_ALL_RESULT_ISICS:
          return {
            ...state,
            dataResultForGraph: state.dataResultForGraph.map((isic) => {
              return { ...isic, selected: action.selectionStatus === "ALL" || action.selectionStatus === "SOME" ? false : true }
            })
        }
        default:
            return state;
    }
}

export default dataResultsReducer;


// WEBPACK FOOTER //
// ./src/features/modules/survey-data-visualization/data-results/DataResultsReducer.js